function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 7,
  d: "M-.03 19.22h33.71M50.05 19.22h13.98"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 41.07,
  cy: 19.22,
  r: 7.45,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 7
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 7,
  d: "M64.03 44.68H30.32M13.95 44.68H-.03"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.93,
  cy: 44.68,
  r: 7.45,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 7
});

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZmlsdGVyPC90aXRsZT48bGluZSB4MT0iLTAuMDMiIHkxPSIxOS4yMiIgeDI9IjMzLjY4IiB5Mj0iMTkuMjIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNyIvPjxsaW5lIHgxPSI1MC4wNSIgeTE9IjE5LjIyIiB4Mj0iNjQuMDMiIHkyPSIxOS4yMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI3Ii8+PGNpcmNsZSBjeD0iNDEuMDciIGN5PSIxOS4yMiIgcj0iNy40NSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI3Ii8+PGxpbmUgeDE9IjY0LjAzIiB5MT0iNDQuNjgiIHgyPSIzMC4zMiIgeTI9IjQ0LjY4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjciLz48bGluZSB4MT0iMTMuOTUiIHkxPSI0NC42OCIgeDI9Ii0wLjAzIiB5Mj0iNDQuNjgiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNyIvPjxjaXJjbGUgY3g9IjIyLjkzIiBjeT0iNDQuNjgiIHI9IjcuNDUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNyIvPjwvc3ZnPg==";
export { SvgFilter as ReactComponent };